import { Injectable } from '@angular/core';
import { Login } from '../models/Login.model';
import { HttpService } from '../shared/services/http.service';
import { tap } from 'rxjs';
import { SimpleRequestString } from '../shared/models/SimpleRequestString';
import { ApiRoutesEnum } from '../shared/enums/ApiRoutes.enum';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(private httpService: HttpService) {}

  login(login: Login) {
    return this.httpService.login(login).pipe(
      tap((data) => {
        localStorage.setItem('JWT', data.Data);
      })
    );
  }

  verifyCode(login: SimpleRequestString) {
    return this.httpService.verifyCode(login).pipe(
      tap((data) => {
      })
    );
  }

  getUserByEmail(data: SimpleRequestString) {
    return this.httpService.getUserByEmail(data).pipe(
      tap((data) => {
      })
    );
  }

  resendVerificationCode(data: SimpleRequestString) {
    return this.httpService.resendVerificationCode(data).pipe(
      tap((data) => {
      })
    );
  }

  sendVerificationEmail(data: SimpleRequestString) {
    return this.httpService.sendVerificationEmail(data).pipe(
      tap((data) => {
      })
    );
  }

  sendVerificationCodeSMS(data: SimpleRequestString) {
    return this.httpService.post<boolean>(ApiRoutesEnum.SenVerificationCode, data).pipe(
      tap((data) => {
      })
    );
  }

  verifyCodeEmail(data: SimpleRequestString) {
    return this.httpService.verifyCodeEmail(data).pipe(
      tap((data) => {
      })
    );
  }
}
